import React from 'react';
import { Button } from "react-materialize";
import Drawer from 'react-toolbox/lib/drawer';
import {connect} from "react-redux";

class CWDrawer extends React.Component {
    constructor(props) {
        super(props)

        // State defining the child's component
        this.state = {
            form: null,
            item: null,
            active: true,
            destroyer: null,
            dirty: false,
        }
    }

    closeDrawer() {
        this.setState({active: false}, () => {
            this.props.dispatch(this.state.destroyer);
        })
    }

    render() {
        return (
            <Drawer
                active={this.props.active}
                onOverlayClick={this.handleToggle}
                type="right"
                className={"edit-drawer depth-" + this.props.depth} >
                <br />
                <Button className="close-drawer" floating onClick={() => this.props.closeDrawer()} icon="close" />
                {this.props.outlet &&
                    <this.props.outlet {...this.props}
                                       openDrawer={(component, item, destroyer) => this.setState({form: component, item: item, active: true, destroyer: destroyer})}
                                       closeDrawer={this.closeDrawer} />}
                {this.state.form &&
                    <CWDrawer dispatch={this.props.dispatch}
                              outlet={this.state.form}
                              item={this.state.item}
                              active={this.state.active}
                              depth={this.props.depth + 1}
                              closeDrawer={() => this.closeDrawer.bind(this)()}
                              className={"edit-drawer depth-" + this.props.depth}/>}
            </Drawer>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
    });
})(CWDrawer);


// WEBPACK FOOTER //
// ./src/components/drawer/CWDrawer.js